import styled from '@emotion/styled';
import { Css, Responsive } from '../../../../ui';

export const PressReleaseSectionWrapper = styled.div`
	margin: ${Css.pxToRem(80)} 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		margin: ${Css.pxToRem(60)} 0;
	}
`;

export const StyledPressReleaseSectionHeader = styled.h3`
	margin-bottom: ${Css.pxToRem(24)};
`;
